import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';
import { ChangeSchedulePreviewDto } from '@/features/dashboard/bookingChanges/types/dto/ChangeSchedulePreviewDto.ts';
import { isCachedOpenChange } from '@/features/dashboard/bookingChanges/hooks/useGetOpenDraft.ts';

/**
 * Harmonogram rat przeliczony dla trzech wariantów dopłaty (krok W2).
 *
 * `enabled` rozstrzyga się w chwili odpytania — patrz `useGetChangePreview`:
 * po wprowadzeniu paczki jej podgląd kończy się odmową.
 */
const useGetSchedulePreview = (
  bookingId: string | undefined,
  changeId: string | undefined,
) => useQuery(getSchedulePreviewQueryOptions(bookingId, changeId));

export const getSchedulePreviewQueryOptions = (
  bookingId: string | undefined,
  changeId: string | undefined,
): UseQueryOptions<ChangeSchedulePreviewDto> => ({
  queryKey: bookingChangesApiQueryKeys.schedulePreview(
    bookingId ?? '',
    changeId ?? '',
  ),
  queryFn: () => bookingChangesApi.getSchedulePreview(bookingId!, changeId!),
  enabled: () => isCachedOpenChange(bookingId, changeId),
  staleTime: 1000 * 30,
});

export default useGetSchedulePreview;
